import NetworkingOperations from "../index";

const PaypalInit = (data) => {
	const url = process.env.REACT_APP_PAYPAL_INIT;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaypalInit;
